/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

import { MolSerializer } from 'ketcher-core';

const molSerializer = new MolSerializer();

export default [
  `Benzene
  Ketcher  5112215552D 1   1.00000     0.00000     0

  6  6  0  0  0  0            999 V2000
    0.6548    2.2452    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0813    2.2456    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3694    2.6575    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0813    1.4204    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6548    1.4167    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3712    1.0086    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  3  1  2  0     0  0
  1  5  1  0     0  0
  5  6  2  0     0  0
  6  4  1  0     0  0
  4  2  2  0     0  0
  2  3  1  0     0  0
M  END`,

  `Cyclopentadiene
  Ketcher  5112215552D 1   1.00000     0.00000     0

  5  5  0  0  0  0            999 V2000
    3.8091    8.2444    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3091    6.7055    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6181    7.6510    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3091    6.7055    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0000    7.6510    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  5  1  0     0  0
  5  4  2  0     0  0
  4  2  1  0     0  0
  2  3  2  0     0  0
  3  1  1  0     0  0
M  END`,

  `Cyclohexane
  Ketcher  5112215552D 1   1.00000     0.00000     0

  6  6  0  0  0  0            999 V2000
    2.5500    3.6722    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5500    2.6722    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4160    2.1722    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2820    2.6722    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2820    3.6722    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4160    4.1722    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  6  1  1  0     0  0
  1  2  1  0     0  0
  2  3  1  0     0  0
  3  4  1  0     0  0
  4  5  1  0     0  0
  5  6  1  0     0  0
M  END`,

  `Cyclopentane
  Ketcher 11161218352D 1   1.00000     0.00000     0

  5  5  0     0  0            999 V2000
    0.8090    1.5389    0.0000 C   0  0  0  0  0  0        0  0  0
    1.6180    0.9511    0.0000 C   0  0  0  0  0  0        0  0  0
    1.3090    0.0000    0.0000 C   0  0  0  0  0  0        0  0  0
    0.3090    0.0000    0.0000 C   0  0  0  0  0  0        0  0  0
    0.0000    0.9511    0.0000 C   0  0  0  0  0  0        0  0  0
  1  5  1  0     0  0
  5  4  1  0     0  0
  4  3  1  0     0  0
  3  2  1  0     0  0
  2  1  1  0     0  0
M  END`,

  `Cyclopropane
  Ketcher  5112215552D 1   1.00000     0.00000     0

  3  3  0  0  0  0            999 V2000
    2.6123    1.5663    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6098    1.5663    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1111    2.4280    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0     0  0
  2  3  1  0     0  0
  3  1  1  0     0  0
M  END`,

  `Cyclobutane
  Ketcher  5112215552D 1   1.00000     0.00000     0

  4  4  0  0  0  0            999 V2000
    3.4956    1.8862    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4919    2.8804    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4846    1.8991    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4821    2.8804    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0     0  0
  2  4  1  0     0  0
  4  3  1  0     0  0
  3  1  1  0     0  0
M  END`,

  `Cycloheptane
  Ketcher  5112215552D 1   1.00000     0.00000     0

  7  7  0  0  0  0            999 V2000
   21.4111    6.3389    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   22.1938    6.9555    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   23.1653    6.7333    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   23.5987    5.8389    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   21.4166    5.3333    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   23.1660    4.9333    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
   22.1938    4.7111    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  2  1  1  0     0  0
  1  5  1  0     0  0
  5  7  1  0     0  0
  7  6  1  0     0  0
  6  4  1  0     0  0
  4  3  1  0     0  0
  3  2  1  0     0  0
M  END`,

  `Cyclooctane
  Ketcher  5112215552D 1   1.00000     0.00000     0

  8  8  0  0  0  0            999 V2000
    2.9268    2.2122    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9270    3.2099    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6288    3.9118    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6290    1.5102    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6266    1.5102    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3286    2.2122    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3285    3.2099    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6266    3.9119    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  2  1  1  0     0  0
  1  4  1  0     0  0
  4  5  1  0     0  0
  5  6  1  0     0  0
  6  7  1  0     0  0
  7  8  1  0     0  0
  8  3  1  0     0  0
  3  2  1  0     0  0
M  END`,
].map((structStr) => molSerializer.deserialize(structStr));
